import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { SectionsPropsType } from '../types';
import { wait } from '../../../utils';
import { renderCtaButton } from '../../views/CtaButton';
import { scrollToBottomOfChat } from '../../functional/scrollToBottomOfChat';

const SECTION_KEY_NAME = 'ctaButton';

export const ctaButtonSection = async (props: SectionsPropsType) => {
  // CTAボタン
  await renderCtaButton({
    ...props,
    keyName: SECTION_KEY_NAME,
  });

  scrollToBottomOfChat();

  await wait(1)

  // 個人情報入力欄出現後にフッターを表示する
  document.querySelector<HTMLElement>('.footer').classList.remove('is-hidden');
};
